export const DEFAULT_SEO = {
  ogType: 'website',
  locale: 'es_AR',
  twitterCard: 'summary_large_image',
  descriptionMaxLength: 160,
};
